const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'access_token';
const LOCAL_STORAGE_ACCESS_TOKEN_EXPIRATION_KEY = 'access_token_expiration';
const GUARDED_API_REQUEST_FAILED = 'GUARDED_API_REQUEST_FAILED';
const REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 60;
const SIGNUP_FLOW_TYPE_EMAIL = 'email';
const SIGNUP_FLOW_TYPE_FACEBOOK = 'facebook';
const SIGNUP_FLOW_TYPE_APPLE = 'apple';

export {
  LOCAL_STORAGE_ACCESS_TOKEN_KEY,
  LOCAL_STORAGE_ACCESS_TOKEN_EXPIRATION_KEY,
  GUARDED_API_REQUEST_FAILED,
  REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS,
  SIGNUP_FLOW_TYPE_EMAIL,
  SIGNUP_FLOW_TYPE_FACEBOOK,
  SIGNUP_FLOW_TYPE_APPLE
};
